import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { QueueSelectionPurpose } from 'src/app/samwebDescription/samwin/QueueSelectionPurpose';
import { QueueShortInfoRemoteDto } from 'src/generated/swagger';
import { LongRunningAction } from '../../server-communication/running-actions/types/longRunningAction.decorator';

@LongRunningAction(LongRunningContextCategoryTyp.GLOBAL)
export class StartQueueSelectionProcess {
   public static readonly type = '[QueueSelectionDialog] Start Selection Process';

   constructor(public purpose: QueueSelectionPurpose, public contextData?: any, public currentSkillId?: number) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.GLOBAL)
export class CompleteQueueSelectionProcess {
   public static readonly type = '[QueueSelectionDialog] Complete Queue Selection';
}

export class EndQueueSelectionProcess {
   public static readonly type = '[QueueSelectionDialog] End Queue Selection';
}

export class QueueSelectionSelectQueue {
   public static readonly type = '[QueueSelectionDialog] Select Queue';

   constructor(public queue: QueueShortInfoRemoteDto) {}
}

export class QueueSelectionSearchTextChanged {
   public static readonly type = '[QueueSelectionDialog] Search Text Changed';

   constructor(public searchText: string) {}
}
